<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <!-- <el-row>
          <el-col :span="8"> -->
          <el-form :inline="true" :model="searchCondition">
            <el-form-item label="时间">
				<WarnMonthPicker @dataSearch="dataSearch"/>
              <el-button @click="searchButton" style="color: #1890ff">查询</el-button>
              <el-button @click="backLastPage" type="danger">返回</el-button>
            </el-form-item>
          </el-form>
        <!-- </el-col>
         <el-col :span="16">
          <div id="chartmain" :style="{
              width: '90%',
              height: '200px',
              padding: '20px',
              borderRadius: '25px',
              boxShadow:
                '0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)',
            }"></div>
        </el-col>
        </el-row> -->
        <ApeTable ref="apeTable" :data="companyList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @rowClick="rowClick" @switchPaging="switchPaging" highlight-current-row >
          <el-table-column
            v-if="buttonType=='text'"
            width="160"
            header_align='center'
            align='center'
            label="服务时间">
            <template slot-scope="scope">{{searchCondition.start_time}}至{{ scope.row.statistics_date }}</template>
          </el-table-column>
        <el-table-column
            v-if="buttonType=='text'"
            width="160"
            header_align='center'
            align='center'
            label="应支付酬劳">
            <template slot-scope="scope">
				{{ scope.row.send_money }}
            </template>
          </el-table-column>
        <el-table-column
            v-if="buttonType=='text'"
            width="160"
            header_align='center'
            align='center'
            label="状态"><div class="warn-list-danger-div">下发超过300万,请谨慎审核</div></el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import WarnMonthPicker from '@/components/WarnMonthPicker.vue'
import { mapGetters, mapState} from 'vuex'
import ScreeCompany from '@/components/ScreeCompany.vue'
import MonthPicker from '@/components/MonthPicker.vue'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    WarnMonthPicker,
    ScreeCompany,
    MonthPicker
  },
  data() {
    return {
      checkList: ['选中且禁用','复选框 A'],
      companyFormData: {
        category_id: [],
        name: []
      },
      categoryList: [],
      signUrl: '',//签约链接
      outerVisible: false,//外层模态框状态
      innerVisible: false,//内层模态框状态
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      searchCategory: [],
      // 搜索条件
      searchCondition:{
      },
      loadingStaus: true,
      columns: [
        {
          title: '申请公司',
          value: 'company_name',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '姓名',
          value: 'name',
          header_align: 'center',
          align: 'center',
        },
		{
          title: '身份证号',
          value: 'id_number',
          header_align: 'center',
          align: 'center',
        }
      ],
      // 表格列表数据
      companyList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证
      rules: {
        title: [
          {required: true, message: '输入标题', trigger: 'blur' },
        ],
        type: [
          {required: true, message: '选择类型', trigger: 'blur' },
        ],
        is_new_win: [
          {required: true, message: '选择打开发方式', trigger: 'blur' },
        ],
        is_show: [
          {required: true, message: '选择状态', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '正在加载中……',
        title: '',
        width_height: '640px',
        show_footer:false,
      },
      // 附件列表
      attachmentList:[],
      // 附件列表字段定义
      attachmentColumns: [
        {
          title: '标题',
          value: 'title',
        }
      ],
      // 添加附件
      dialogData:{
        visible: false,
        title: '',
        width: '24%',
        loading: true,
        modal: false
      },
      // 附件表单内容
      formData:{},
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
      // 当前需要操作附件的文章id
      currentCompanyId:0,
      isCheck: true,//是否禁用确定按钮
      category_Id: '',
      category_name: '',
      id: '',
      OrImage: '',
      is_import: '',
      options: [{
          value: 'xlsx',
          label: 'xlsx'
        }, {
          value: 'csv',
          label: 'csv'
        }, {
          value: 'txt',
          label: 'txt'
        }
      ],
      value: 'xlsx',
      bookType: 'xlsx',//导出表格类型
      downloadLoading: false,
      // 允许显示的字段
      allowField: ['companyId', 'settlementId'],
      data1: [],
      data2: [],
    }
  },

  computed: {
    ...mapGetters(['userPermissions','buttonType']),
    ...mapState({
      userInfo: state => state.userInfo,
    }),
  },
  watch: {
    "$route.matched" : function(n,o) {
      console.log(o)
      if (n.length === 2) {
        this.init()
      }
    }
  },
  filters: {
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return Y + M + D;
    },
  },
  methods: {
    //导出
    async handleDownload() {
      this.isExport = true;
      this.downloadLoading = true
      let list = await this.init('export')
      import('@/excel/Export2Excel').then( excel => {
        const tHeader = ['ID','姓名','性别','生日','qq','手机号码','证件号码', '服务类型', '身份正面照片', '身份反面照片', '创建时间',];
        const data = this.formatJson(list)
        const time = new Date().getTime() + Math.random() * 1000
        let filename = `人才签约${time}`
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType //Optional
        })
        this.downloadLoading = false;
      })
    },
    //转换导出数据
    formatJson(jsonData) {
      return jsonData.map(v =>{
        let {
          id,
          fullname,
          alias_sex,
          birthday,
          qq,
          mobile,
          id_number,
          category_name,
          id_img_positive,
          id_img_back,
          created_at
        } = v
        return [ id,fullname,alias_sex,birthday,qq,mobile,id_number,category_name,id_img_positive,id_img_back,created_at]
      })
    },
    //选择导出类型
    selectData(e) {
      this.bookType = e;
    },
    // 导出日期
    MonthSearch(v) {
      if (v) {
        this.searchCondition.start_time = v[0]
        this.searchCondition.end_time = v[1]
      }
      this.init('search')
    },
    ScreeCompany(v, name) {
      if(name == 'company') {
        if (v) {
          this.searchCondition.company_id = v
        } else {
          delete this.searchCondition.company_id
        }
        this.init('search')
      }
      if(name == 'settlement') {
        if (v) {
          this.searchCondition.channel_account = v
        } else {
          delete this.searchCondition.channel_account
        }
        this.init('search')
      }
    },
    //获取支持批量人才状态
    async isImport() {
      let args = {
        companyId: this.$route.params.company_id
      }
      let result = await this.$api.isImport(args)
      if(result) {
        this.is_import = result.is_import
        console.log("this.is_import", this.is_import)
      }
    },
    //关闭二维码弹窗
    closeQRDialog() {
      this.outerVisible = false
      this.innerVisible = false
      this.companyFormData = {
        category_id: [],
        name: []
      };
    },
    htmlToPdf(category_name, channel_name, company_name, created_at, sign_url, sign_type, fullname, id_number) {
      let routeData = this.$router.resolve({
        path: "/customer/exportpdf",
        query: {category_name, channel_name, company_name, created_at, sign_url, sign_type, fullname, id_number}
      });
      window.open(routeData.href, '_blank');
    },
    //复选框选择时间
    handleTaskChange(val) {
      if(val) {
        this.isCheck = false
        this.categoryList.find((value) => {
          this.companyFormData.name.forEach((item, index) => {
            if(item == value.name) {
              this.companyFormData.name[index] = value.name
              this.companyFormData.category_id[index] = value.id
            }
          })
        });
        this.category_Id = this.companyFormData.category_id.join("、")
        this.category_name = this.companyFormData.name.join("、")
        const { company_id, settlement_id } = this.userInfo
        this.signUrl = encodeURI(`${this.$config.uniBaseURL}#/pages/sign/login?companyId=${company_id}&settlementId=${settlement_id}&categoryId=${this.category_Id}&categoryName=${this.category_name}&location=${this.mxDomain.location}`)
      }
    },
    //获取签约链接
    async cusomerLink() {
      this.categoryList = await this.$api.getCustomerCategoryList()
      this.outerVisible = true;
    },
    //关闭内层小dialog×
    handleInnerClose() {
      this.innerVisible = false;
    },
    //关闭外层dialog小×
    handleOuterClose() {
      this.outerVisible = false;
      this.companyFormData = {
        category_id: [],
        name: []
      };
    },
    //取消内层dialog
    innerClose() {
      this.innerVisible = false;
    },
    checkCategory() {
      if(this.companyFormData.category_id != ''){
        this.getQRCode()
      }
    },
    // 创建二维码
    async createQrCode(id) {
      let path = `pages/mission/detail?id=${id}&companyId=${this.mxCompanyId}&settlementId=${this.mxSettlementId}`
      let args = {
        path: path,
        appId: this.mxDomain.appId
      }
      let res = await this.$api.createQrcode(args)
      if (res) {
        this.OrImage = res
      }
    },
    async getQRCode() {
      let nameList = [], names,remark, name
      this.companyFormData.name.forEach((item) => {
       nameList.push(item.substring(0,item.length-2))
      })
      names = nameList.join("、")
      name = `${names}`
      remark = `因委托方业务发展，现需要若干有相关服务经验或能力的自由职业者提供${this.companyFormData.name.join("、")}，具体要求和费用由委托方公布。`
      let args = {
        name,
        remark,
        category_id: this.companyFormData.category_id.join("、"),
        category_name: this.companyFormData.name.join("、")
      }
      let res = await this.$api.getQRCode(args)
      if(res) {
        this.innerVisible = true
        this.createQrCode(res)
      }
    },

    // 搜索
    searchButton() {
      this.init('search')
    },
    //导入跳转
    importExcel() {
      this.$router.push({path: 'customer/import'})
    },
    // 切换页码操作
    async switchPaging() {
      this.init()
    },
	// 点击行切换统计图数据
	async rowClick(row){
		this.curveChart(row)
	},
    // 响应添加按钮
    async addButton() {
      // this.$router.push(this.$route.path+'/create')
    },
    // 响应详情按钮
    async viewButton(id) {
      console.log(id)
      this.$router.push(this.$route.path+'/'+id+'/view')
    },
    // 响应编辑按钮
    async editButton(id) {
      console.log(id)
      // this.$router.push(this.$route.path+'/'+id+'/edit')
    },
    // 相应删除按钮
    async deleteButton(id) {
      console.log(id)
      let info = await this.$api.deleteCustomer(id)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.init('del')
        })
      } else {
        this.$message.error(info)
      }
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.start_time = value[0]
      this.searchCondition.end_time = value[1]
    },
    replaceStr(str) {
      const middleValue = str.substring(4,14)
      return str = `****${middleValue}****`
    },
    // // 导出表格-分每次1000+页码切换
    // async exportExcel(){
    //   let pagingInfo = { 
    //     current_page:1,
    //     page_size:1000
    //   }
    //   let res = await this.$api.getCustomerList(pagingInfo)
    //   let {data} = await this.$api.getCustomerList(pagingInfo)

    //   let arr = res.data.push(...data)

    //   console.log(arr)

    // },
    // 初始化列表
    async init(type) {
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      if (type == 'export') {
        pagingInfo.page_size = 50000
        console.log(pagingInfo,'页面对象')
        return false
      } else {
        this.loadingStaus=true
      }
      if(type == 'search') {
        pagingInfo.current_page = 1
      }
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
        // console.log(searchCondition,'条件')
      let {data, pages} = await this.$api.getWarnList(searchCondition)
      data = data.filter((item) => {
        // return item.id_number = item.id_number.replace(/([\d]{4})\d{10}([\d]|[\s]{4})/, '$1*********$2')
		item.id_number_text = item.id_number;
        item.id_number = this.replaceStr(item.id_number)
		item.statistics_date = item.statistics_date.toString().slice(0,4)+'-'+item.statistics_date.toString().slice(4)
        return item
      })
      if (type == 'export') {
        return data
      } else {
        this.companyList = []
        this.$nextTick(() => {
          this.companyList=data
        })
        this.pagingData.total = pages.total
        // console.log(this.pagingData.total,'总数')
        this.offset = pages.offset
        this.loadingStaus=false
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {tenant_id:"289707619174600704"}
      if (this.searchCondition.fullname) {
        condition.fullname = this.searchCondition.fullname
      }
      if (this.searchCondition.sign_type) {
        condition.sign_type = this.searchCondition.sign_type
      }
      if (this.searchCondition.start_time) {
        condition.start_time = this.searchCondition.start_time
      }
      if (this.searchCondition.end_time) {
        condition.end_time = this.searchCondition.end_time
      }
      if (this.searchCondition.company_id) {
        condition.company_id = this.searchCondition.company_id
      }
      if (this.searchCondition.channel_account) {
        condition.channel_account = this.searchCondition.channel_account
      }
      return condition
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.dialogData.loading_text = '正在提交中……'
      this.dialogData.loading = true
      this.formData.company_id = this.currentCompanyId
      let id = await this.$api.saveCompanyAttachment(this.formData)
      this.$nextTick(() => {
        this.dialogClose()
      })
      this.$nextTick(() => {
        if (id) {
          this.initCompanyAttachmentList()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['companyAttacmentForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.formData = {}
      this.attachmentUploadFileList = []
    },
    // 响应添加附件按钮
    async addAttachment() {
      this.dialogData.visible = true
      this.dialogData.loading = false
      this.dialogData.title = '添加附件'
    },
    // 相应删除文章附件按钮
    async deleteCompanyAttachmentButton(id) {
      let info = await this.$api.deleteCompanyAttachment(id)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.initCompanyAttachmentList()
        })
      } else {
        this.$message.error(info)
      }

    },
    keyupSubmit(){
      document.onkeydown = e => {
        console.log(e)
        let _key=window.event.keyCode;
        if(_key === 13){
          this.searchButton()
        }
      }
    },//曲线图表
    curveChart(row) {
      const newTime = new Date();
      const endTe = this.$options.filters["timestampToTime"];
      var newTimeDate = endTe(newTime);
      if(row.statistics_date) {
			newTimeDate = endTe(newTime);
		}
      const today = newTimeDate.split("-")[1];
      const data = [];
      const data1 = [];
      var lastMonthDay = 12;
      let previousDays = 7 - today;
      let previousStart = lastMonthDay - previousDays;
      const startTe = this.searchCondition.start_time;
      const startTeMonth = startTe.split("-")[1];
      for (let i = startTeMonth; i <= lastMonthDay; i++) {
        if (i > 9) {
          data.push(startTe.split("-")[0] + "-" + i);
        } else {
          data.push(
            startTe.split("-")[0] + "-" + "0" + i
          );
        }
      }
      for (let i = previousStart; i <= lastMonthDay; i++) {
        if (i > 9) {
          data.push(newTimeDate.split("-")[0] + "-" + i);
        } else {
          data.push(
            newTimeDate.split("-")[0] + "-" + "0" + i
          );
        }
      }
      for (let j = 1; j < today; j++) {
        if (j > 9) {
          data.push(
            newTimeDate.split("-")[0] +
              "-" +
              j
          );
        } else {
          data.push(
            newTimeDate.split("-")[0] +
              "-" +
              "0" +
              j
          );
        }
      }
      data.push(newTimeDate.split("-")[0]+'-'+newTimeDate.split("-")[1]);
      data1.push(newTimeDate.split("-")[0]+'-'+newTimeDate.split("-")[1]);
      var data_1 = Array.from(new Set(data));
      this.start_time = data_1[0];
      this.end_time = data_1[data_1.length - 1];
      let args1 = {
        start_time: data_1[0],
        end_time: data_1[data_1.length - 1],
        channel_account: this.channel_account,
      };
      if (!this.channel_account) {
        delete args1.channel_account;
      }
      this.getRecharge(args1, data_1,row);
    },
	async getRecharge(data, data1,row) {
		if(this.searchCondition.start_time) {
			data.start_time = this.searchCondition.start_time;
		}
		data.end_time = data.end_time.split("-")[0]+'-'+data.end_time.split("-")[1];
		data.id_number = row.id_number_text;
		data.tenant_id = '289707619174600704';
      let result = await this.$api.getWarnStatistics(data);
      var xdata = [];
      this.data1 = [];
      if (result) {
        result.forEach((item) => {
          item.date=item.statistics_date.toString().substring(0,4)+'-'+item.statistics_date.toString().substring(4,6);
          if (data1.includes(item.date)) {
            // let index = data1.findIndex((value) => value == item.date)-1;
            this.data1[this.data1.length] = parseFloat(item.send_money);
            xdata.push(item.date);
          }
        });
      }
      let myChart = this.$echarts.init(document.getElementById("chartmain"));
      myChart.setOption({
        title: {
          text: "统计",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        legend: {
          // data: ["近7天", "近30天"],
          data: ["金额"],
          selectedMode: "single",
          right: 50,
        },
        //数据区域缩放、滚动条
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            start: 1,
            end: 130,
          },
          {
            type: "inside",
            xAxisIndex: [0],
            start: 1,
            end: 130,
          },
        ],
        xAxis: {
          data: xdata,
        },
        yAxis: {},
        series: [
          {
            name: "金额",
            type: "line",
            data: this.data1,
          },
        ],
      });
      myChart.on("legendselectchanged", function (obj) {
        var name = obj.name;
        var option = myChart.getOption();
        if (name == "金额") {
          option.xAxis[0].data = xdata;
          this.start_time = xdata[0];
          this.end_time = xdata[xdata.length - 1];
        }
        myChart.setOption(option, true);
      });
    },
	async backLastPage(){
		this.$router.go(-1)
	}
  },
  created() {
    // let { company_id, settlement_id } = this.userInfo
    this.keyupSubmit()
  },
  mounted() {
    this.init()
    this.curveChart({id_number_text:'',statistics_date:''});
    // this.exportExcel()
    // this.isImport()
  },
}
</script>

<style lang="stylus" scoped>
  /deep/.el-checkbox-group label
    width: 180px
  /deep/.el-checkbox-group label:first-child
    margin-left: 10px
  /deep/.el-checkbox-group
    // width: 660px
  .el-button
    margin-right 4px
    margin-bottom 4px
  .item-name
    width: 130px
  .table-header-gai
    height: 35px
  .table-header
    margin-bottom 12px
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .returnBtn
    position: relative
    top: 10px
    float: right
  .table-right
    float right
  .submitBtn
    float right
    margin-top: 20px
  .link-url
    color: #fff
    text-decoration:none
  .cusomer-link-gai
    position: absolute;
    top: 0
    font-size: 15px
    width: 160px
  .cusomer-link
    position: absolute;
    top: 0
    right: 0
  .total-num
    position: absolute;
    top: 0
    right: 0
    line-height: 40px
    padding-right: 20px
  .span-num
    color: #f00
  .selectWord
    width: 150px
  .link-title
    text-align: center
    padding-bottom: 10px
    color: red
  .people-btn-wrapper
    margin-top:20px
  .dialog-title
    display: flex
    justify-content: center
    align-items: center;
    margin-bottom: 20px
    margin-top: -20px
  .title-text
    font-size: 20px
    margin-left: 10px
  .center-box
    display: flex
    justify-content: center
    align-item: center
    padding: 30px 0
  .QR-code
    width: 150px
    height: 150px
  .main-page-content
    position: relative
  .warn-list-danger-div
    background-color: #F56C6C
    color: white
    border-radius: 3px
    font-size: 12px
    padding: 7px 8px
</style>
